module.exports = "//static.hsappstatic.net/visitor-ui-component-library/static-1.3528/img/default-avatar.png"